import styled from 'styled-components'

const BaseButton = styled.button`
  padding: 4px 16px;
  border-radius: 8px;
  outline-color: ${({ theme }) => theme.colors.blue};
  width: 100%;
  border: 1px solid ${({ theme }) => theme.colors.gray4};
  box-sizing: border-box;
  color: ${({ theme }) => theme.colors.white};
  background-color: ${({ disabled, theme }) => (disabled ? theme.colors.disabled : theme.colors.confirm)};
`

export const ConfirmButton = styled(BaseButton)`
  width: 100%;
`

export const ButtonContainer = styled.div`
  flex: 1;
  margin: 0 12px 12px;
`
